export enum ApplicationMode {
  Live = 0,
  Test = 1,
}
export type TransactionModel = "Credit" | "Debit";
export enum BusinessOrderType {
  Recipients = 1,
  Download = 2,
}
